module.exports = ".modal-content {\r\n  min-height: 25vh;\r\n}\r\n\r\n"